import React, { ReactElement, useEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";

// project imports
import { Outlet, useLocation, useParams } from "react-router-dom";
import {
  Drawer,
  Grid,
  IconButton,
  List,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
//import Footer from "layout/Dashboard/Footer";
import { SelectField } from "components/@extended/SelectField";
import { IDropdownModel } from "common/models/IDropdownModel";
import { useForm } from "react-hook-form";
import { ILibraryID } from "../store/api/types";
import useOPACStore from "../store/useOPACStore";
import { GetOPACLibrary } from "../api/hooks";
import NavItem from "./NavItem";
import { HomeOutlined, TeamOutlined } from "@ant-design/icons";
import { GridMenuIcon } from "@mui/x-data-grid";
import { getClientCodeFromUrl } from "config";
// ==============================|| HORIZONTAL MENU LIST ||============================== //

interface ElevationScrollProps {
  children: ReactElement;
  window?: Window | Node;
}

function ElevationScroll({ children, window }: ElevationScrollProps) {
  const theme = useTheme();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window!,
  });

  theme.shadows[4] = theme.customShadows.z1;

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

// ==============================|| HORIZONTAL MENU LIST ||============================== //

const OPACLayout = () => {
  const { setLibraryID } = useOPACStore();
  const { control, watch, reset } = useForm<ILibraryID>({});
  const { data: result } = GetOPACLibrary();
  const [libraryOptions, setLibraryOptions] = useState<IDropdownModel[]>([]);
  const libID = watch("libraryID");

  useEffect(() => {
    if (result?.apiData && result.apiData.length > 0) {
      setLibraryOptions(result.apiData);
      const LibCode = window.localStorage.getItem("libCode");
      const matchedLib = result.apiData.find(
        (item) => item.id?.toString() === LibCode
      );

      const targetId = matchedLib ? matchedLib.id : result.apiData[0].id;
      reset({ libraryID: targetId });
      setLibraryID(targetId);
      window.localStorage.setItem("libCode", targetId?.toString() ?? "");
    }
  }, [result]);

  useEffect(() => {
    if (libID != undefined && libID !== null) {
      setLibraryID(libID);
      window.localStorage.setItem("libCode", libID?.toString());
    }
  }, [libID]);

  const items = [
    { title: "Home", to: `/`, icon: <HomeOutlined color="text.primary" /> },
    {
      title: "Member Status",
      to: "/memberdetail",
      icon: <TeamOutlined color="text.primary" />,
    },
    // {
    //   title: "Login",
    //   to: "/login",
    //   icon: <UserOutlined color="text.primary" />,
    // },
  ];
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };
  const { pathname } = useLocation();
  const { materialID } = useParams();

  const [header, setHeader] = useState<string>();

  useEffect(() => {
    if (pathname == "/") {
      setHeader("OPAC (Online Public Access Catalogue)");
    } else if (pathname == "/memberdetail") {
      setHeader("OPAC : Member Current Issue Status");
    } else if (pathname == "/login") {
      setHeader(null);
    } else if (pathname == `/information/${materialID}`) {
      setHeader("Material Details");
    }
  }, [pathname]);
  return (
    <>
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <ElevationScroll>
          <AppBar
            position="absolute"
            sx={{
              backgroundColor: "#1e1e2d",
              color: "#ffffff",
              boxShadow: "0px 0px 40px 0px rgba(82, 63, 105, 0.1)",
              zIndex: 97,
              height: 65,
            }}
          >
            <Grid
              container
              // direction="row"
              justifyContent="space-between"
              //alignItems="center"
              sx={{ height: "100%" }}
            >
              <Grid
                item
                //sx={{ display: "flex", alignItems: "center", mx: 2 }}
                sx={{
                  backgroundColor: "#009687",
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: 2,
                  clipPath: "polygon(0 0, 100% 0, 85% 100%, 0% 100%)",
                  width: { xs: "55%", sm: "300px" },
                }}
              >
                <Typography
                  mx={1}
                  sx={{
                    fontWeight: 900,
                    color: "#ffffff",
                    fontSize: "28px",
                  }}
                >
                  Library OPAC
                </Typography>
              </Grid>

              {isMd && (
                // <Stack
                //   sx={{
                //     display: "flex",
                //     flexDirection: "row",
                //     alignItems: "center",
                //     paddingLeft: "1rem",
                //   }}
                // >
                <Grid
                  item
                  xs
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingRight: 4,
                  }}
                >
                  <Stack direction="row" alignItems="center">
                    {items.map((item) => (
                      <NavItem
                        key={item.title}
                        item={{
                          title: item.title,
                          url: item.to,
                          icon: item.icon,
                          isMd: isMd,
                        }}
                      />
                    ))}
                  </Stack>
                </Grid>
              )}

              {isMd && (
                <Grid
                  item
                  xs={6}
                  md={4}
                  sm={4}
                  lg={3}
                  marginRight={2}
                  sx={{
                    justifyContent: "space-around",
                    alignContent: "center",
                  }}
                >
                  <SelectField
                    control={control}
                    backgroundColor="white"
                    name="libraryID"
                    options={libraryOptions}
                    placeholder="Select Library"
                    disableClearable={true}
                  />
                </Grid>
              )}

              {!isMd && (
                <Grid
                  item
                  sx={{
                    justifyContent: "space-around",
                    alignContent: "center",
                  }}
                >
                  <IconButton
                    color="inherit"
                    aria-label="menu"
                    onClick={() => toggleDrawer(true)}
                  >
                    <GridMenuIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </AppBar>
        </ElevationScroll>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => toggleDrawer(false)}
        >
          <Box
            sx={{
              width: 250,
              height: "100%",
              paddingTop: 5,
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <List>
              {items.map((item) => (
                <NavItem
                  key={item.title}
                  item={{
                    title: item.title,
                    url: item.to,
                    icon: item.icon,
                    isMd: isMd,
                  }}
                />
              ))}
            </List>
            <List>
              <Grid
                item
                xs={6}
                md={4}
                sm={4}
                lg={3}
                px={2}
                sx={{ justifyContent: "space-around" }}
              >
                <SelectField
                  control={control}
                  name="libraryID"
                  options={libraryOptions}
                  placeholder="Select Library"
                  disableClearable={true}
                />
              </Grid>
            </List>
          </Box>
        </Drawer>
        <AppBar
          position="absolute"
          sx={{
            top: 65,
            background: "white",
            width: "100%",
            height: 50,
            justifyContent: "center",
            borderTop: "1px solid",
            borderTopColor: "divider",
            borderBottom: "1px solid",
            borderBottomColor: "divider",
            color: "black",
          }}
        >
          <Grid container direction={"row"} justifyContent={"start"}>
            <Grid
              item
              xs={6}
              md={4}
              lg={3}
              marginLeft={{ xs: 2, sm: 4 }}
              justifyContent={"start"}
              whiteSpace={"nowrap"}
            >
              <Typography
                sx={{ fontSize: { xs: 16, sm: 18, md: 22 }, fontWeight: 700 }}
              >
                {header}
              </Typography>
            </Grid>
          </Grid>
        </AppBar>
        <Box
          component="main"
          sx={{
            backgroundColor: "#e0e0e0",
            width: "100%",
            flexGrow: 1,
            p: { xs: 2, sm: 3 },
          }}
        >
          <Grid
            container
            sx={{
              p: 1,
              px: 0,
              mx: 0,
              top: 90,
              position: "relative",
              minHeight: "calc(95vh - 110px)",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Outlet />
            </Box>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default OPACLayout;
